import { createReducer } from '../../../utils/fsa';
import { popupClosed } from '../../popup/action_creators/popup';
import {
  formError,
  formSent,
  IActionUserClaimsData,
  setUserClaimsData,
} from '../action_creators/user_claims';

export interface IUserClaimsState extends IActionUserClaimsData {
  sent: boolean;
  error: Error;
}

export default createReducer<IUserClaimsState>()

  .on(formSent, (state, action) => {
    return Object.assign({}, state, {
      sent: true,
      error: null,
    });
  })

  .on(formError, (state, action) => {
    return Object.assign({}, state, {
      sent: false,
      error: action.payload.error,
    });
  })

  .on(popupClosed, (state, action) => {
    return Object.assign({}, state, {
      sent: false,
      error: null,
    });
  })

  .on(setUserClaimsData, (state, { payload: {
    isPIK, oid, subscribeAbGroup, offerRequestReferer,
  }}) => {
    return Object.assign({}, state, {
      oid,
      isPIK,
      subscribeAbGroup,
      offerRequestReferer,
    });
  })

  .build({
    sent: false,
    error: null,
    oid: null,
    isPIK: false,
    subscribeAbGroup: null,
    offerRequestReferer: undefined,
  });



// WEBPACK FOOTER //
// ./src/bundles/user_claims/reducers/user_claims.ts